export default __webpack_public_path__ + "static/media/seta_gf.2c93e817.gif";